// A parent is greeted by title and surname, "Mrs Jenkins". A parent without a title on their
// contact record is greeted by their full name, "Lena Allcroft", as the medicine emails are.
const TITLE_THEN_SURNAME = /@Title(?:\s|&nbsp;)+@ParentSurname/g;

const present = value => typeof value === 'string' ? value.trim().length > 0 : value != null;

export const greetWithoutTitle = (text, {title, parentFullName} = {}) =>
    !present(title) && present(parentFullName)
        ? (text ?? '').replace(TITLE_THEN_SURNAME, parentFullName.trim())
        : text;
